globalThis.HsSeoMedia = {
  "products": [
    {
      "handle": "hydrogelfolie-smartphone",
      "title": "Hydrogel folie - Smartphone",
      "url": "/products/hydrogelfolie-smartphone",
      "image": "https://cdn.shopify.com/s/files/1/0269/8546/3889/files/hydrogel-folie-smartphone-3805864.png?v=1788953725",
      "width": 1254,
      "height": 1254
    },
    {
      "handle": "ipad-7-8-generation-schutzglas-mit-halterung",
      "title": "iPad 7, 8 & 9 Generation Schutzglas blasenfrei anbringen dank Montage-Halterung",
      "url": "/products/ipad-7-8-generation-schutzglas-mit-halterung",
      "image": "https://cdn.shopify.com/s/files/1/0269/8546/3889/files/ipad-7-8-9-generation-schutzglas-635320.jpg?v=1738955496",
      "width": 720,
      "height": 720
    },
    {
      "handle": "ipad-10-generation-schutzglas",
      "title": "iPad 10 & 11 Generation Schutzglas blasenfrei anbringen dank Montage-Halterung",
      "url": "/products/ipad-10-generation-schutzglas",
      "image": "https://cdn.shopify.com/s/files/1/0269/8546/3889/files/ipad-10-generation-schutzglas-315318.jpg?v=1738955497",
      "width": 720,
      "height": 720
    },
    {
      "handle": "clazo-smart-rugged-touch-keyboard",
      "title": "ClaZo Smart Rugged Keyboard",
      "url": "/products/clazo-smart-rugged-touch-keyboard",
      "image": "https://cdn.shopify.com/s/files/1/0269/8546/3889/files/clazo-smart-rugged-touch-keyboard-453794.png?v=1747165666",
      "width": 1080,
      "height": 1080
    },
    {
      "handle": "clazo-smart-rugged-touch-keyboard-1",
      "title": "ClaZo Smart Rugged Touch Keyboard",
      "url": "/products/clazo-smart-rugged-touch-keyboard-1",
      "image": "https://cdn.shopify.com/s/files/1/0269/8546/3889/files/clazo-smart-rugged-touch-keyboard-453794.png?v=1747165666",
      "width": 1080,
      "height": 1080
    },
    {
      "handle": "clazo-digitale-tasche",
      "title": "ClaZo Digitale Tasche",
      "url": "/products/clazo-digitale-tasche",
      "image": "https://cdn.shopify.com/s/files/1/0269/8546/3889/files/clazo-pencil-lumo-688949.png?v=1753880881",
      "width": 1080,
      "height": 1080
    },
    {
      "handle": "ersatzspitzen-fur-deinen-clazo-lumo-pencil",
      "title": "Ersatzspitzen für deinen ClaZo Lumo Pencil",
      "url": "/products/ersatzspitzen-fur-deinen-clazo-lumo-pencil",
      "image": "https://cdn.shopify.com/s/files/1/0269/8546/3889/files/ersatzspitzen-fur-deinen-clazo-lumo-pencil-526350.png?v=1747892144",
      "width": 1080,
      "height": 1080
    },
    {
      "handle": "usb-c-auf-usb-c-kabel-clazo-lumo",
      "title": "Ersatzkabel USB C auf USB C - 10W",
      "url": "/products/usb-c-auf-usb-c-kabel-clazo-lumo",
      "image": "https://cdn.shopify.com/s/files/1/0269/8546/3889/files/ersatzkabel-usb-c-auf-usb-c-10w-339002.png?v=1750524582",
      "width": 1080,
      "height": 1080
    },
    {
      "handle": "clazo-pencil-lumo",
      "title": "ClaZo Pencil Lumo",
      "url": "/products/clazo-pencil-lumo",
      "image": "https://cdn.shopify.com/s/files/1/0269/8546/3889/files/clazo-pencil-lumo-1062469.png?v=1778722483",
      "width": 1254,
      "height": 1254
    },
    {
      "handle": "clazo-nexus-gan-pps-stecker-20w",
      "title": "ClaZo Nexus GaN PPS Stecker 20W",
      "url": "/products/clazo-nexus-gan-pps-stecker-20w",
      "image": "https://cdn.shopify.com/s/files/1/0269/8546/3889/files/clazo-nexus-gan-pps-stecker-20w-7206801.png?v=1757845810",
      "width": 521,
      "height": 376
    },
    {
      "handle": "iphone-armor-x-anti-shock-case-with-magsafe",
      "title": "iPhone Armor-X MagSafe Hülle – iPhone 12–17 Modelle",
      "url": "/products/iphone-armor-x-anti-shock-case-with-magsafe",
      "image": "https://cdn.shopify.com/s/files/1/0269/8546/3889/files/iphone-armor-x-anti-shock-case-with-magsafe-7572507.webp?v=1768171511",
      "width": 2000,
      "height": 2000
    },
    {
      "handle": "apple-ipad-11-gen-a16-hulle",
      "title": "Apple iPad 10 & 11. Gen A16 Hülle",
      "url": "/products/apple-ipad-11-gen-a16-hulle",
      "image": "https://cdn.shopify.com/s/files/1/0269/8546/3889/files/apple-ipad-10-11-gen-a16-hulle-8515821.webp?v=1771762154",
      "width": 1500,
      "height": 1500
    }
  ],
  "productKinds": {
    "pencil": [
      "clazo-pencil-lumo"
    ],
    "tips": [
      "ersatzspitzen-fur-deinen-clazo-lumo-pencil"
    ],
    "cable": [
      "usb-c-auf-usb-c-kabel-clazo-lumo"
    ],
    "charger": [
      "clazo-nexus-gan-pps-stecker-20w"
    ],
    "keyboard": [
      "clazo-smart-rugged-touch-keyboard"
    ],
    "keyboardTouch": [
      "clazo-smart-rugged-touch-keyboard-1"
    ],
    "bag": [
      "clazo-digitale-tasche"
    ],
    "film": [
      "hydrogelfolie-smartphone"
    ],
    "tabletGlass": [
      "ipad-10-generation-schutzglas"
    ],
    "phoneCase": [
      "iphone-armor-x-anti-shock-case-with-magsafe"
    ],
    "tabletCase": [
      "apple-ipad-11-gen-a16-hulle"
    ],
    "accessories": [
      "clazo-pencil-lumo",
      "clazo-smart-rugged-touch-keyboard",
      "clazo-digitale-tasche"
    ]
  },
  "photos": {
    "display": {
      "url": "https://cdn.shopify.com/s/files/1/0269/8546/3889/files/bali-indonesia-september-2023-damaged-260nw-2363678731.webp?v=1755799154",
      "alt": "Gebrochenes Display eines Smartphones",
      "width": 800,
      "height": 484
    },
    "iphoneBoard": {
      "url": "https://cdn.shopify.com/s/files/1/0269/8546/3889/files/WhatsApp_Image_2026-02-12_at_21.09.53.jpg?v=1770927593",
      "alt": "iPhone-Platinen bei der Fehlerdiagnose",
      "width": 800,
      "height": 600
    },
    "iphoneBack": {
      "url": "https://cdn.shopify.com/s/files/1/0269/8546/3889/files/WhatsApp_Image_2026-02-12_at_21.09.53_1.jpg?v=1770927783",
      "alt": "Beschädigte iPhone-Rückseite und ausgebaute Bauteile",
      "width": 800,
      "height": 1067
    },
    "macBoard": {
      "url": "https://cdn.shopify.com/s/files/1/0269/8546/3889/files/WhatsApp_Video_2026-06-06_at_21.56.16_Frame_3.jpg?v=1780776085",
      "alt": "Ausgebautes MacBook-Logicboard bei der Diagnose",
      "width": 800,
      "height": 1067
    },
    "macOpen": {
      "url": "https://cdn.shopify.com/s/files/1/0269/8546/3889/files/WhatsApp_Image_2026-06-06_at_21.54.03.jpg?v=1780776086",
      "alt": "Geöffnetes MacBook mit sichtbarem Akku",
      "width": 800,
      "height": 1067
    },
    "macMicroscope": {
      "url": "https://cdn.shopify.com/s/files/1/0269/8546/3889/files/WhatsApp_Image_2026-06-13_at_22.35.54.jpg?v=1781383405",
      "alt": "MacBook-Logicboard unter dem Mikroskop",
      "width": 800,
      "height": 1067
    },
    "gpu": {
      "url": "https://cdn.shopify.com/s/files/1/0269/8546/3889/files/WhatsApp_Image_2026-06-06_at_20.36.32.jpg?v=1780771283",
      "alt": "Grafikkarten-Platine am Reparaturplatz",
      "width": 800,
      "height": 1067
    },
    "bga": {
      "url": "https://cdn.shopify.com/s/files/1/0269/8546/3889/files/ChatGPT_Image_6._Juni_2026_20_41_06.png?v=1780771285",
      "alt": "BGA-Lötstation mit Platine",
      "width": 800,
      "height": 600
    },
    "data": {
      "url": "https://cdn.shopify.com/s/files/1/0269/8546/3889/files/abc39868.jpg?v=1764860192",
      "alt": "Ausgebauter Speicherchip",
      "width": 800,
      "height": 1067
    },
    "macData": {
      "url": "https://cdn.shopify.com/s/files/1/0269/8546/3889/files/unn22amed.jpg?v=1789672719",
      "alt": "Geöffnetes MacBook am Messplatz",
      "width": 800,
      "height": 1067
    },
    "androidBoard": {
      "url": "https://cdn.shopify.com/s/files/1/0269/8546/3889/files/WhatsApp_Bild_2025-12-05_um_13.51.08_e2413883.jpg?v=1764939413",
      "alt": "Smartphone-Platine mit ausgebautem Speicherchip",
      "width": 800,
      "height": 1067
    },
    "tabletOpen": {
      "url": "https://cdn.shopify.com/s/files/1/0269/8546/3889/files/WhatsApp_Video_2026-06-06_at_21.56.19_Frame_1.jpg?v=1780776086",
      "alt": "Geöffnetes Tablet mit Akku und Platine",
      "width": 800,
      "height": 1067
    },
    "phoneWater": {
      "url": "https://cdn.shopify.com/s/files/1/0269/8546/3889/files/hs-seo-phoneWater-20261008.png?v=1791442867",
      "alt": "Wasserschaden am Smartphone – Illustration",
      "width": 1536,
      "height": 1024
    },
    "iphoneNoPower": {
      "url": "https://cdn.shopify.com/s/files/1/0269/8546/3889/files/hs-seo-iphoneNoPower-20261008.png?v=1791442875",
      "alt": "Diagnose eines iPhones ohne Funktion – Illustration",
      "width": 1536,
      "height": 1024
    },
    "tabletDisplay": {
      "url": "https://cdn.shopify.com/s/files/1/0269/8546/3889/files/hs-seo-tabletDisplay-20261008.png?v=1791442883",
      "alt": "Displayreparatur eines beschädigten Tablets – Illustration",
      "width": 1536,
      "height": 1024
    },
    "macDisplay": {
      "url": "https://cdn.shopify.com/s/files/1/0269/8546/3889/files/hs-seo-macDisplay-20261008.png?v=1791443356",
      "alt": "Displayreparatur am MacBook – Illustration",
      "width": 1536,
      "height": 1024
    },
    "macWater": {
      "url": "https://cdn.shopify.com/s/files/1/0269/8546/3889/files/hs-seo-macWater-20261008.png?v=1791443365",
      "alt": "Flüssigkeitsschaden am MacBook – Illustration",
      "width": 1536,
      "height": 1024
    },
    "macInput": {
      "url": "https://cdn.shopify.com/s/files/1/0269/8546/3889/files/hs-seo-macInput-20261008.png?v=1791443373",
      "alt": "Trackpad und Tastatur am MacBook – Illustration",
      "width": 1536,
      "height": 1024
    },
    "phoneBattery": {
      "url": "https://cdn.shopify.com/s/files/1/0269/8546/3889/files/hs-seo-phoneBattery-20261008.png?v=1791443383",
      "alt": "Akkuwechsel am Smartphone – Illustration",
      "width": 1536,
      "height": 1024
    },
    "phoneCharge": {
      "url": "https://cdn.shopify.com/s/files/1/0269/8546/3889/files/hs-seo-phoneCharge-20261008.png?v=1791443391",
      "alt": "Reparatur der Smartphone-Ladebuchse – Illustration",
      "width": 1536,
      "height": 1024
    },
    "phoneCamera": {
      "url": "https://cdn.shopify.com/s/files/1/0269/8546/3889/files/hs-seo-phoneCamera-20261008.png?v=1791443399",
      "alt": "Austausch einer Smartphone-Kamera – Illustration",
      "width": 1536,
      "height": 1024
    },
    "imacDisplay": {
      "url": "https://cdn.shopify.com/s/files/1/0269/8546/3889/files/hs-seo-imacDisplay-20261008.png?v=1791443492",
      "alt": "Displayreparatur am iMac – Illustration",
      "width": 1536,
      "height": 1024
    },
    "imacBoard": {
      "url": "https://cdn.shopify.com/s/files/1/0269/8546/3889/files/hs-seo-imacBoard-20261008.png?v=1791443501",
      "alt": "Mainboard-Diagnose am iMac – Illustration",
      "width": 1536,
      "height": 1024
    },
    "tabletWater": {
      "url": "https://cdn.shopify.com/s/files/1/0269/8546/3889/files/hs-seo-tabletWater-20261008.png?v=1791443511",
      "alt": "Wasserschaden am Tablet – Illustration",
      "width": 1536,
      "height": 1024
    },
    "tabletBattery": {
      "url": "https://cdn.shopify.com/s/files/1/0269/8546/3889/files/hs-seo-tabletBattery-20261008.png?v=1791443519",
      "alt": "Akkuwechsel am Tablet – Illustration",
      "width": 1536,
      "height": 1024
    },
    "tabletCharge": {
      "url": "https://cdn.shopify.com/s/files/1/0269/8546/3889/files/hs-seo-tabletCharge-20261008.png?v=1791443529",
      "alt": "Ladebuchsenreparatur am Tablet – Illustration",
      "width": 1536,
      "height": 1024
    },
    "laptopBoard": {
      "url": "https://cdn.shopify.com/s/files/1/0269/8546/3889/files/hs-seo-laptopBoard-20261008.png?v=1791443538",
      "alt": "Mainboard-Diagnose am Notebook – Illustration",
      "width": 1536,
      "height": 1024
    },
    "consoleBattery": {
      "url": "https://cdn.shopify.com/s/files/1/0269/8546/3889/files/hs-seo-consoleBattery-20261008.png?v=1791444405",
      "alt": "Akkuwechsel an einer geöffneten Nintendo Switch – Illustration",
      "width": 1536,
      "height": 1024
    },
    "desktopBoard": {
      "url": "https://cdn.shopify.com/s/files/1/0269/8546/3889/files/hs-seo-desktopBoard-20261008.png?v=1791444417",
      "alt": "Diagnose an einem geöffneten Desktop-PC – Illustration",
      "width": 1536,
      "height": 1024
    },
    "macMiniBoard": {
      "url": "https://cdn.shopify.com/s/files/1/0269/8546/3889/files/hs-seo-macMiniBoard-20261008.png?v=1791444426",
      "alt": "Logicboard-Diagnose an einem geöffneten Mac mini – Illustration",
      "width": 1536,
      "height": 1024
    }
  }
};
